import React from 'react';
import { EditShiftSetModal } from './edit-shift-set-modal.component';
import { useEditShiftSetModalService } from './edit-shift-set-modal.service';
import type { EditShiftSetModalContainerProps } from './edit-shift-set-modal.types';

export const EditShiftSetModalContainer = (
  props: EditShiftSetModalContainerProps,
) => {
  const serviceProps = useEditShiftSetModalService(props);
  return <EditShiftSetModal {...serviceProps} />;
};
